import { redirectToLogin } from "./annoucement-sheet";
import { api, language } from "./api";
import authHeader from "./auth-header";
export type DropdownDataWithLanguage = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
};
type DepartmentsResponse = {
  module_id: number;
  status: boolean;
  categoryTableData: TData;
};

export type TData = {
  data: DepartmentInfo[];
  total: number;
};
export type DepartmentInfo = {
  id?: number;
  name: string;
};
type departmentInput = {
  // sort: string;
  // search: string;
};
export type TaskCategoriesList = {
  categoryList: TaskDepartmentListData[];
};
export type TaskDepartmentListData = {
  id: number;
  name: string;
};

export const categoryApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCategoryList: build.query<DepartmentsResponse, departmentInput>({
      query: () => ({
        url: `categories`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getCategoryAllList: build.query<TaskCategoriesList, void>({
      query: () => ({
        url: `getCategoryList`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    createCategory: build.mutation<
    TaskCategoriesList,
      DropdownDataWithLanguage
    >({
      query(body) {
        return {
          headers: authHeader(),
          url: `categories`,
          body,
          method: "POST",
        };
      },
    }),
    updateCategory: build.mutation<
    TaskCategoriesList,
      DropdownDataWithLanguage
    >({
      query(body) {
        return {
          headers: authHeader(),
          url: `categories/${body.id}`,
          body,
          method: "PUT",
        };
      },
      // invalidatesTags: (employees) => {
      //   return [{ type: "Departments", id: "LIST" }];
      // },
    }),
    deleteCategory: build.mutation<TaskCategoriesList, number>({
      query(id) {
        return {
          headers: authHeader(),
          url: `/categories/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: (employees) => {
        return [{ type: "Category", id: "LIST" }];
      },
    }),
  }),
});

export const {
  useGetCategoryAllListQuery,
  useGetCategoryListQuery,
  useUpdateCategoryMutation,
  useCreateCategoryMutation,
  useDeleteCategoryMutation
} = categoryApi;

export const {
  endpoints: {
    getCategoryList,
    getCategoryAllList,
    createCategory,
    updateCategory,
    deleteCategory,
  },
} = categoryApi;
